/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PublicationTypesWithRelations } from './publicationTypesWithRelations';
import { BusinessUnitWithRelations } from './businessUnitWithRelations';
import { CityWithRelations } from './cityWithRelations';
import { CompanyWithRelations } from './companyWithRelations';
import { PublicationDetailWithRelations } from './publicationDetailWithRelations';
import { UserWithRelations } from './userWithRelations';
import { InteractionWithRelations } from './interactionWithRelations';


/**
 * (tsType: PublicationWithRelations, schemaOptions: { includeRelations: true })
 */
export interface PublicationWithRelations { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: string;
    name: string;
    description: string;
    coverPhotoUrl: string;
    fileUrl?: string;
    externalUrl?: string;
    discount?: string;
    showInPopup?: boolean;
    publishedOn?: string;
    expirationDate?: string | null;
    webPublishedOn?: string;
    published?: boolean;
    isPinned?: boolean;
    celebratedUserId?: number | null;
    yearsOfService?: number | null;
    publicationTypeId: string;
    publicationTypes?: PublicationTypesWithRelations;
    businessUnits?: Array<BusinessUnitWithRelations>;
    companies?: Array<CompanyWithRelations>;
    users?: Array<UserWithRelations>;
    publicationDetails?: Array<PublicationDetailWithRelations>;
    interactions?: Array<InteractionWithRelations>;
    cities?: Array<CityWithRelations>;
}

